import React, {
  forwardRef,
  RefObject,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { VestigingEnum } from '../../../shared/models/Enum'
import { IKlant } from '../../../shared/models/IKlant'
import { AflAdrLosseKopersService } from '../../../services/AflAdrLosseKopersService'
import { Button } from 'react-bootstrap'
import NumericTextboxComponent from 'react-numeric-textbox'
import { ISearchReference } from 'shared/models/References'

interface IProps {
  onError?: (error: string) => void
  onInputChanged?: () => void
  onLoading?: (isLoading: boolean) => void
  onResult?: (result: IKlant) => void
  warehouse: VestigingEnum
  service: AflAdrLosseKopersService
  showAARSelectie?: boolean
  showWarehouseSelectie?: boolean
}

function SearchKoper(props: IProps, ref: RefObject<ISearchReference>) {
  const [customerNumber, setCustomerNumber] = useState<number>(null)
  const [agreementReference, setAgreementReference] = useState<string>('')
  const [showAARselectie, setShowAARselectie] = useState<boolean>(true)
  const [showWarehouseselectie, setShowWarehouseselectie] =
    useState<boolean>(true)

  useEffect(() => {
    if (props.showAARSelectie != null) {
      setShowAARselectie(props.showAARSelectie)
    }
    if (props.showWarehouseSelectie != null) {
      setShowWarehouseselectie(props.showWarehouseSelectie)
    }
  }, [])

  useImperativeHandle(ref, () => ({
    search: () => {
      searchCustomer()
    },
  }))

  const re = /^[0-9\b]+$/

  const updateCustomer = x => {
    if (re.test(x) || x === null) {
      setAgreementReference('')
      setCustomerNumber(x)
      if (!!props.onInputChanged) {
        props.onInputChanged()
      }
    }
  }

  const updateReference = x => {
    setAgreementReference(x.target.value)
    setCustomerNumber(null)
    if (!!props.onInputChanged) {
      props.onInputChanged()
    }
  }

  const searchCustomer = async () => {
    if (!!customerNumber && `${customerNumber}`.length > 9 && !!props.onError) {
      props.onError(`${customerNumber} is geen geldig klantnummer.`)
    } else if (
      (!!customerNumber && customerNumber > 0) ||
      (!!agreementReference && agreementReference.length > 0)
    ) {
      if (!!props.onLoading) {
        props.onLoading(true)
      }
      const result = await props.service.searchCustomer(
        customerNumber,
        agreementReference,
        props.warehouse
      )
      if (result.success && !!props.onResult) {
        props.onResult(result.payLoad)
      } else if (!!props.onError) {
        props.onError(result.errorMessage)
      }

      if (!!props.onLoading) {
        props.onLoading(false)
      }
    } else if (!!props.onError) {
      props.onError(
        'Kies eerst een (geldig) klantnummer en/of afspraakreferentie'
      )
    }
  }

  const searchCustomerIfEnter = (e: string) => {
    if (e === 'Enter') {
      searchCustomer()
    }
  }

  return (
    <table className='selectie'>
      <thead>
        <tr>
          <th className='selectie-label'>Klantnummer:</th>
          {showAARselectie && (
            <th className='selectie-label'>Afspraakreferentie:</th>
          )}
          {showWarehouseselectie && (
            <th className='selectie-label'>Vestiging:</th>
          )}
          <th className='selectie-label'></th>
        </tr>
      </thead>
      <tbody>
        <tr onKeyUp={e => searchCustomerIfEnter(e.key)}>
          <td>
            <NumericTextboxComponent
              min={0}
              max={999999}
              decimals={0}
              format={'0'}
              value={customerNumber}
              onChange={updateCustomer}
            />
          </td>
          {showAARselectie == true && (
            <td>
              <input value={agreementReference} onChange={updateReference} />
            </td>
          )}
          {showWarehouseselectie && <td>{VestigingEnum[props.warehouse]}</td>}
          <td>
            <div className='row no-gutters'>
              <div className='col'></div>
              <div className='col-auto'>
                <Button
                  variant='primary'
                  disabled={!customerNumber && !agreementReference}
                  onClick={searchCustomer}
                >
                  Zoek Klant
                </Button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}
export default forwardRef(SearchKoper)
